import Vue from 'vue'
import App from './App'
import Vuex from 'vuex'
import store from './store'
import router from './router'
import './plugins/element'
import './assets/js/common'
import './service/request' // 导入request.js以初始化axios拦截器
import { getCache, setCache } from './service/cache'

// 导入并全局注册 CodeEditor 组件
import CodeEditor from './components/CodeEditor.vue'

// 全局导入 echarts-gl 以支持 3D 图表
import 'echarts-gl'

// 注释掉开发环境API监控工具导入，避免打包错误
// 如需使用，可在浏览器控制台手动导入
// if (process.env.NODE_ENV === 'development') {
//   const loadApiMonitor = async () => {
//     try {
//       await import('./assets/js/apiStatusMonitor.js');
//     } catch (e) {
//       console.warn('API状态监控工具加载失败:', e);
//     }
//   };
//   loadApiMonitor();
// }

Vue.use(Vuex)
// 全局注册 CodeEditor 组件
Vue.component('CodeEditor', CodeEditor)
Vue.config.productionTip = false

// 立即注册 preventReClick 指令（同步方式，避免竞态条件）
// 先尝试使用增强版，失败则降级到基础版
try {
  const enhancedModule = require('./assets/js/enhancedClickStatefrom.js')
  const { preventReClick } = enhancedModule
  Vue.directive('preventReClick', preventReClick)
} catch (e) {
  console.warn('增强版 preventReClick 加载失败，使用基础版:', e.message)
  try {
    const basicModule = require('./assets/js/clickStatefrom.js')
    const { preventReClick } = basicModule
    Vue.directive('preventReClick', preventReClick)
  } catch (fallbackError) {
    console.error('基础版 preventReClick 加载失败，使用内置降级方案:', fallbackError.message)
    // 使用内置降级方案
    Vue.directive('preventReClick', {
      inserted: function (el, binding) {
        el.addEventListener('click', function(e) {
          if (!el.disabled && !el.__preventReClick) {
            el.__preventReClick = true
            setTimeout(() => {
              el.__preventReClick = false
            }, binding.value || 3000)
          } else if (el.disabled || el.__preventReClick) {
            e.preventDefault()
            e.stopPropagation()
          }
        }, true)
      }
    })
  }
}

// 隐藏加载状态
const hideLoading = () => {
  const loading = document.getElementById('loading')
  if (loading) {
    loading.remove() // 改为彻底移除元素，而不只是隐藏
  }
}

// 延迟加载非关键依赖（preventReClick 已在上面同步加载，此处不再需要）
const loadPreventReClick = async () => {
  // 现在此函数只用于其他延迟加载，preventReClick 已在初始化时加载
}

// 图片预加载
// const preloadImages = () => {
//   const imageUrls = [
//     './assets/img/login_part.png',
//     './assets/img/login_pic.png',
//     './assets/img/side_icon17.png',
//     './assets/img/side_icon17_active.png',
//     './assets/img/side_icon24.png',
//     './assets/img/side_icon24_active.png'
//   ]
//   imageUrls.forEach(url => {
//     const img = new Image()
//     img.src = url
//   })
// }

router.beforeEach((to, from, next) => {
  // 个人档案直接放行，避免被权限或其他守卫拦截
  if (to.path === '/profile' || to.name === 'Profile') {
    next();
    return;
  }

  // 隐私协议/用户协议：登录页面必须能直接访问，避免任何守卫拦截
  if (to.name === 'PrivacyPermission' || to.path === '/privacy-permission'
      || to.name === 'LoginAgreement' || to.path === '/login-agreement') {
    console.log('[route guard] allow agreement page', to.path, to.name);
    next();
    return;
  }
  let token = localStorage.getItem('mental_token');
  let raw = localStorage.getItem('mental_user_info');
  let info = raw ? JSON.parse(raw) : null;
  
  if(info){
    if(to.name === 'Login'){
      if(info.type == 'student'){
        next({name: 'stuHome',query: {type: '7'}});
      } else if(info.type === 'admin') {
        // 管理员已登录，直接跳转到管理员首页
        next({ path: '/admin_home' });
      } else {
        // 获取角色权限
        let rbac = info.rbac || [];
        
        // 根据角色名称控制权限
        if(info.type === 'teacher') {
          // 先移除团体测评子页面权限，确保权限完全由module_permission控制
          rbac = rbac.filter(perm => perm !== 'sc_4');
          
          // 确保所有老师都有教务管理权限（包括测评管理主菜单和自我测评）
          const teacherBasicPermissions = ['1', '2', '5', '11', '12', '13', '6', 'sc_1', 'sc_2', 'sc_3', 'sc_5', 'sc_6', 'sc_7', 'sc_8', 'sc_9', 'sc_12', 'sc_27', 'sc_28', 'sc_22'];
          teacherBasicPermissions.forEach(perm => {
            if(!rbac.includes(perm)) {
              rbac.push(perm);
            }
          });
          
          if(info.role_name && info.role_name.includes('校长')) {
            // 校长不显示预约管理权限（20、sc_18、sc_19、sc_20、sc_21、sc_22、sc_23、sc_24）
            const appointmentPermissions = ['20', 'sc_18', 'sc_19', 'sc_20', 'sc_21', 'sc_22', 'sc_23','sc_24'];
            rbac = rbac.filter(perm => !appointmentPermissions.includes(perm));
            
          } else if(info.role_name && info.role_name.includes('管理员')) {
            // 管理员：特殊处理心理咨询室权限
            // 先移除所有心理咨询室相关权限
            const counselingPermissions = ['18', 'sc_13', 'sc_14', 'sc_15', 'sc_16', 'sc_17'];
            const appointmentPermissions = ['20', 'sc_18', 'sc_19', 'sc_20', 'sc_21', 'sc_22', 'sc_23', 'sc_24'];
            rbac = rbac.filter(perm => !counselingPermissions.includes(perm));
            rbac = rbac.filter(perm => !appointmentPermissions.includes(perm));
            
          } else if(info.role_name && (info.role_name.includes('咨询') || info.role_name.includes('心理'))) {
            // 咨询老师：不显示功能室管理权限，但保留教务管理权限
            const counselingPermissions = ['18', 'sc_13', 'sc_14', 'sc_15', 'sc_16', 'sc_17'];
            
            // 移除功能室管理权限，但保留教务管理权限
            rbac = rbac.filter(perm => !counselingPermissions.includes(perm));
            
          } else {
            // 普通班级老师：不显示功能室管理权限和预约管理权限，但保留教务管理权限
            const counselingPermissions = ['18', 'sc_13', 'sc_14', 'sc_15', 'sc_16', 'sc_17'];
            const appointmentPermissions = ['20', 'sc_18', 'sc_19', 'sc_20', 'sc_21', 'sc_22', 'sc_23','sc_24'];
            
            // 移除相关权限，但保留教务管理权限
            rbac = rbac.filter(perm => !counselingPermissions.includes(perm));
            rbac = rbac.filter(perm => !appointmentPermissions.includes(perm));
            // 班级老师：不显示系统日志（sc_11）
            rbac = rbac.filter(perm => perm !== 'sc_11');
          }
          
          // 基于module_permission的权限控制
          if(info.module_permission && Array.isArray(info.module_permission)) {
            // 如果module_permission数组包含心理沙盘解析，就将心理沙盘解析的菜单以及下面的子页面权限给用户
            if(info.module_permission.includes('心理沙盘解析')) {
              const sandboxPermissions = ['24',  'sc_25', 'sc_26'];
              sandboxPermissions.forEach(perm => {
                if(!rbac.includes(perm)) {
                  rbac.push(perm);
                }
              });
            }
            
            // 如果module_permission数组包含心理咨询室，根据角色分配不同权限
            if(info.module_permission.includes('心理咨询室')) {
              if(info.role_name && (info.role_name.includes('校长') || info.role_name.includes('管理员'))) {
                // 校长和管理员：显示功能室管理权限及其所有子页面
                const counselingPermissions = ['18', 'sc_13', 'sc_14', 'sc_15', 'sc_16', 'sc_17', 'sc_22'];
                counselingPermissions.forEach(perm => {
                  if(!rbac.includes(perm)) {
                    rbac.push(perm);
                  }
                });
              } else if(info.role_name && (info.role_name.includes('咨询') || info.role_name.includes('心理'))) {
                // 咨询老师：显示预约管理权限
                const appointmentPermissions = ['20', 'sc_18', 'sc_19', 'sc_20', 'sc_21', 'sc_22', 'sc_23'];
                appointmentPermissions.forEach(perm => {
                  if(!rbac.includes(perm)) {
                    rbac.push(perm);
                  }
                });
              }
            }
            
            // 如果module_permission数组包含团体测评，就将团体测评页面给用户
            if(info.module_permission && 
               Array.isArray(info.module_permission) && 
               info.module_permission.includes('团体测评')) {
              const assessmentPermissions = ['sc_4','sc_29'];
              assessmentPermissions.forEach(perm => {
                if(!rbac.includes(perm)) {
                  rbac.push(perm);
                }
              });
            }
            
            // 如果以上三种情况都没有任意一个，就将对应的菜单及其子页面权限不给用户
            if ((!info.module_permission || 
                 !Array.isArray(info.module_permission) ||
                 !info.module_permission.includes('心理沙盘解析')) && 
                (!info.module_permission || 
                 !Array.isArray(info.module_permission) ||
                 !info.module_permission.includes('心理咨询室')) && 
                (!info.module_permission || 
                 !Array.isArray(info.module_permission) ||
                 !info.module_permission.includes('团体测评'))) {
              // 移除相关权限（但保留测评管理主菜单'5'和自我测评权限sc_5, sc_6, sc_7, sc_8, sc_9）
              const removePermissions = ['24', 'sc_25', 'sc_26', '18', 'sc_13', 'sc_14', 'sc_15', 'sc_16', 'sc_17', 'sc_22', 'sc_4','sc_29'];
              rbac = rbac.filter(perm => !removePermissions.includes(perm));
            }
          }
        }
        
        // 只对根路径和特定情况进行重定向，不要对所有登录请求都重定向
        if (to.path === '/index' || to.path === '/') {
          // 动态查找index路由而不是使用硬编码索引
          const indexRoute = router.options.routes.find(route => route.path === '/index');
          if (indexRoute && indexRoute.children) {
            indexRoute.children.map(item => {
              const p_index = rbac.findIndex(item => !item.includes('sc_'));
              if(item.meta.icon == rbac[p_index]){
                if(item.children){
                  const index = rbac.findIndex(item => item.includes('sc_'));
                  item.children.map(el => {
                    if(el.meta.icon == rbac[index]){
                      next({name: el.name,query: {type: el.meta.type,c_id: el.meta.icon}})
                    }
                  })
                }else{
                  next({name: item.name,query: {type: item.meta.icon}})
                }
              }else{
                next(false)
              }
            })
          } else {
            console.error('未找到/index路由或其子路由');
            next(false);
          }
        } else {
          next()
        }
      }
    }else if(
      to.name === 'Password' ||
      to.name === 'Intelligent' ||
      to.name === 'Developer' ||
      to.name === 'LoginGuide' ||
      to.name === 'EducationLogin' ||
      to.name === 'EducationDashboard' ||
      to.name === 'EducationWarningDetail'||
      to.name === 'EducationWarningPyDetail' ||
      // 隐私协议/用户协议允许在未登录状态下查看（登录页需要展示）
      to.name === 'PrivacyPermission'
    ){
      next()
    }else{
      if(to.meta.role == info.type){
        // 管理员角色直接通过，无需额外权限检查
        if(info.type === 'admin') {
          next();
          return;
        }

        let rbac = info.rbac || [];
        
        // 根据角色名称控制权限
        if(info.type === 'teacher') {
          // 先移除团体测评子页面权限，确保权限完全由module_permission控制
          rbac = rbac.filter(perm => perm !== 'sc_4');
          
          // 确保所有老师都有教务管理权限（包括测评管理主菜单和自我测评）
          const teacherBasicPermissions = ['1', '2', '5', '11', '12', '13', '6', 'sc_1', 'sc_2', 'sc_3', 'sc_5', 'sc_6', 'sc_7', 'sc_8', 'sc_9', 'sc_12', 'sc_27', 'sc_28', 'sc_22'];
          teacherBasicPermissions.forEach(perm => {
            if(!rbac.includes(perm)) {
              rbac.push(perm);
            }
          });
          
          if(info.role_name && info.role_name.includes('校长')) {
            // 校长不显示预约管理权限（20、sc_18、sc_19、sc_20、sc_21、sc_22、sc_23、sc_24）
            const appointmentPermissions = ['20', 'sc_18', 'sc_19', 'sc_20', 'sc_21', 'sc_22', 'sc_23','sc_24'];
            rbac = rbac.filter(perm => !appointmentPermissions.includes(perm));
            
          } else if(info.role_name && (info.role_name.includes('咨询') || info.role_name.includes('心理'))) {
            // 咨询老师：不显示功能室管理权限，但保留教务管理权限
            const counselingPermissions = ['18', 'sc_13', 'sc_14', 'sc_15', 'sc_16', 'sc_17'];
            
            // 移除功能室管理权限，但保留教务管理权限
            rbac = rbac.filter(perm => !counselingPermissions.includes(perm));
            
          } else {
            // 普通班级老师：不显示功能室管理权限和预约管理权限，但保留教务管理权限
            const counselingPermissions = ['18', 'sc_13', 'sc_14', 'sc_15', 'sc_16', 'sc_17'];
            const appointmentPermissions = ['20', 'sc_18', 'sc_19', 'sc_20', 'sc_21', 'sc_22', 'sc_23','sc_24'];
            
            // 移除相关权限，但保留教务管理权限
            rbac = rbac.filter(perm => !counselingPermissions.includes(perm));
            rbac = rbac.filter(perm => !appointmentPermissions.includes(perm));
          }
          
          // 基于module_permission的权限控制
          if(info.module_permission && Array.isArray(info.module_permission)) {
            // 如果module_permission数组包含心理沙盘解析，就将心理沙盘解析的菜单以及下面的子页面权限给用户
            if(info.module_permission.includes('心理沙盘解析')) {
              const sandboxPermissions = ['24','sc_25', 'sc_26'];
              sandboxPermissions.forEach(perm => {
                if(!rbac.includes(perm)) {
                  rbac.push(perm);
                }
              });
            }
            
            // 如果module_permission数组包含心理咨询室，根据角色分配不同权限
            if(info.module_permission.includes('心理咨询室')) {
              if(info.role_name && info.role_name.includes('校长')) {
                // 校长：显示功能室管理权限及其所有子页面
                const counselingPermissions = ['18', 'sc_13', 'sc_14', 'sc_15', 'sc_16', 'sc_17', 'sc_22'];
                counselingPermissions.forEach(perm => {
                  if(!rbac.includes(perm)) {
                    rbac.push(perm);
                  }
                });
              } else if(info.role_name && info.role_name.includes('管理员')) {
                // 管理员：显示功能室管理权限及其所有子页面
                const counselingPermissions = ['18', 'sc_13', 'sc_14', 'sc_15', 'sc_16', 'sc_17', 'sc_22'];
                counselingPermissions.forEach(perm => {
                  if(!rbac.includes(perm)) {
                    rbac.push(perm);
                  }
                });
              } else if(info.role_name && (info.role_name.includes('咨询') || info.role_name.includes('心理'))) {
                // 咨询老师：显示预约管理权限
                const appointmentPermissions = ['20', 'sc_18', 'sc_19', 'sc_20', 'sc_21', 'sc_22', 'sc_23'];
                appointmentPermissions.forEach(perm => {
                  if(!rbac.includes(perm)) {
                    rbac.push(perm);
                  }
                });
              }
            }
            
            // 如果module_permission数组包含团体测评，就将团体测评页面给用户
            if(info.module_permission && 
               Array.isArray(info.module_permission) && 
               info.module_permission.includes('团体测评')) {
              const assessmentPermissions = ['sc_4','sc_29'];
              assessmentPermissions.forEach(perm => {
                if(!rbac.includes(perm)) {
                  rbac.push(perm);
                }
              });
            }
            
            // 如果以上三种情况都没有任意一个，就将对应的菜单及其子页面权限不给用户
            if ((!info.module_permission || 
                 !Array.isArray(info.module_permission) ||
                 !info.module_permission.includes('心理沙盘解析')) && 
                (!info.module_permission || 
                 !Array.isArray(info.module_permission) ||
                 !info.module_permission.includes('心理咨询室')) && 
                (!info.module_permission || 
                 !Array.isArray(info.module_permission) ||
                 !info.module_permission.includes('团体测评'))) {
              // 移除相关权限（但保留测评管理主菜单'5'和自我测评权限sc_5, sc_6, sc_7, sc_8, sc_9）
              const removePermissions = ['24', 'sc_25', 'sc_26', '18', 'sc_13', 'sc_14', 'sc_15', 'sc_16', 'sc_17', 'sc_22', 'sc_4','sc_29'];
              rbac = rbac.filter(perm => !removePermissions.includes(perm));
            }
          }
        }
        
        // 白名单：教师个人中心和意见反馈只要 type=teacher 即放行
        if ((to.name === 'TeacherProfile' || to.name === 'SchoolFeedback') && info.type === 'teacher') {
          next();
          return;
        }
        // 学生意见反馈直接放行，避免与其他功能权限码冲突
        if (to.name === 'StudentFeedback' && info.type === 'student') {
          next();
          return;
        }
        // 个人档案跳转放行（消息查看档案等场景）
        if (to.name === 'Profile') {
          next();
          return;
        }
        // 团体测评报告页面放行（从个人档案跳转过来的场景）
        if ((to.name === 'IndividualReport' || to.name === 'Individual') && info.type === 'teacher') {
          next();
          return;
        }

        // 修复权限检查逻辑，支持子路由权限检查
        if(to.meta.role == 'teacher') {
          // 检查主权限（icon）和子权限（auth）
          const hasMainPermission = rbac.indexOf(to.meta.icon) !== -1;
          const hasSubPermission = to.meta.auth && rbac.indexOf(to.meta.auth) !== -1;
          
          // 对于沙盘系统的子路由，需要检查父级权限 '24' 和子级权限
          if(to.meta.icon && to.meta.icon.startsWith('sc_')) {
            // 子路由：需要父级权限和子级权限
            const parentPermission = to.meta.type; // 父级权限ID
            const hasParentPermission = rbac.indexOf(parentPermission) !== -1;
            const hasChildPermission = rbac.indexOf(to.meta.icon) !== -1;
            
            if(hasParentPermission && hasChildPermission) {
              next();
            } else {
              console.warn('权限不足:', {route: to.name, parentPermission, childPermission: to.meta.icon, rbac});
              next(false);
            }
          } else if(to.meta.icon && rbac.indexOf(to.meta.icon) !== -1) {
            // 主路由：检查主权限
            next();
          } else if(hasMainPermission || hasSubPermission) {
            next();
          } else {
            console.warn('权限不足:', {route: to.name, icon: to.meta.icon, auth: to.meta.auth, rbac});
            next(false);
          }
        } else {
          next();
        }
      }else{
        next(false)
      }
    }
  }else{
    // token 存在但用户信息缺失：应用刷新后首次进入时的处理逻辑
    if(token){
      // 检查是否是管理员登录
      const adminToken = localStorage.getItem('mental_admin_token');
      const adminInfo = localStorage.getItem('mental_admin_info');
      const adminPermissions = localStorage.getItem('mental_admin_permissions');

      if (adminToken && adminInfo && adminPermissions &&
          to.path.startsWith('/admin')) {
        // 管理员登录：直接使用已存储的管理员信息，不调用 basicInfo
        try {
          const parsedAdminInfo = JSON.parse(adminInfo);
          const parsedPermissions = JSON.parse(adminPermissions);

          // 构建管理员用户信息对象，符合系统预期格式
          const adminUserInfo = {
            ...parsedAdminInfo,
            type: 'admin',
            rbac: parsedPermissions,
            role: 'admin'
          };

          localStorage.setItem('mental_user_info', JSON.stringify(adminUserInfo));
          next();
          return;
        } catch (error) {
          console.error('解析管理员信息失败:', error);
          // 如果解析失败，清除相关信息并跳转到登录页
          localStorage.removeItem('mental_admin_token');
          localStorage.removeItem('mental_admin_info');
          localStorage.removeItem('mental_admin_permissions');
          localStorage.removeItem('mental_token');
          next({ name: 'LoginGuide' });
          return;
        }
      }

      // 非管理员登录：使用原有的 basicInfo 逻辑
      const { basicInfo } = require('./service/api/getData.js');
      // 先尝试缓存命中：命中则先渲染，后台静默刷新
      const cached = getCache('cache_basic_info');
      if (cached) {
        localStorage.setItem('mental_user_info', JSON.stringify(cached));
        if (cached && Array.isArray(cached.sch_list)) {
          localStorage.setItem('mental_school_list', JSON.stringify(cached.sch_list));
        }
        next();
        basicInfo().then(res => {
          if(res && res.code === 0){
            localStorage.setItem('mental_user_info', JSON.stringify(res.data));
            setCache('cache_basic_info', res.data, 5 * 60 * 1000);
            if (res.data && Array.isArray(res.data.sch_list)) {
              localStorage.setItem('mental_school_list', JSON.stringify(res.data.sch_list));
            }
          }
        });
        return;
      }
      basicInfo().then(res => {
        if(res && res.code === 0){
          localStorage.setItem('mental_user_info', JSON.stringify(res.data));
          setCache('cache_basic_info', res.data, 5 * 60 * 1000);
          // 如果 basicInfo 返回 sch_list，同步写入本地，供 Header 初始化使用
          if (res.data && Array.isArray(res.data.sch_list)) {
            localStorage.setItem('mental_school_list', JSON.stringify(res.data.sch_list));
          }
          // 重新进入当前路由，触发上方 info 分支的权限判断
          next({ ...to, replace: true });
        }else{
          next({name: 'Login'});
        }
      }).catch(() => next({name:'Login'}));
    }else{
      if(
        to.name === 'Login' ||
        to.name === 'Password' ||
        to.name === 'Intelligent' ||
        to.name === 'Developer' ||
        to.name === 'LoginGuide' ||
        to.name === 'EducationLogin' ||
        to.name === 'EducationDashboard' ||
        to.name === 'EducationWarningDetail'||
      to.name === 'EducationWarningPyDetail' ||
      // 隐私协议/用户协议允许在未登录状态下查看（登录页需要展示）
      to.name === 'PrivacyPermission'
      ){
        next()
      }else{
        // 如果访问的是管理员页面，跳转到管理员登录页
        if(to.path.startsWith('/admin')) {
          next({ name: 'LoginGuide' });
        } else {
          next({name: 'Login'});
        }
      }
    }
  }
})

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  mounted() {
    // Vue应用挂载完成后隐藏加载状态
    hideLoading()
    // 异步加载非关键资源
    this.$nextTick(() => {
      loadPreventReClick()
      preloadImages()
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js